/**
 * BookingSettingService
 * Service for managing booking settings per resource type
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for booking setting CRUD operations with resource-type-specific queries
 */
export class BookingSettingService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BookingSettingService.DEFAULT_SERVICE_PATH,
            basePath: BookingSettingService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET BY RESOURCE TYPE ====================
    /**
     * Get booking settings for a specific resource type
     * @param typeId - The bookable resource type ID
     * @returns Booking setting for the resource type
     */
    async getByResourceType(typeId) {
        const response = await this.getByResourceTypeRaw(typeId);
        if (!response.data) {
            throw new Error(`Booking setting for resource type ${typeId} not found`);
        }
        return response.data;
    }
    /**
     * Get booking settings for a specific resource type with full response
     * @param typeId - The bookable resource type ID
     * @returns ResponseData with booking setting
     */
    getByResourceTypeRaw(typeId) {
        const url = this.buildUrl(`by-resource-type/${typeId}`);
        return this.http.get(url);
    }
}
BookingSettingService.DEFAULT_SERVICE_PATH = 'booking-management';
BookingSettingService.BASE_PATH = 'api/booking-settings';
//# sourceMappingURL=BookingSettingService.js.map